module.exports = __webpack_public_path__ + "img/CZ47115289.cbb549ca.svg";